import Spinner from '@/components/Spinner';
import { PageLoadingRegion, VisuallyHiddenText } from './styled';

const PageLoadingFallback = () => (
    <PageLoadingRegion role="status" aria-live="polite">
        <Spinner aria-hidden="true" />
        <VisuallyHiddenText>Loading page</VisuallyHiddenText>
    </PageLoadingRegion>
);

export default PageLoadingFallback;
